import React, { useState, useEffect } from "react";
import { Container, Card, Spinner, Button, Table, Col, Row, Alert } from 'react-bootstrap';
import { CDBCard, CDBDataTable, CDBContainer, CDBCardBody } from 'cdbreact';
import { FaEdit, FaTrash, FaPlus, FaEye,FaArrowLeft } from 'react-icons/fa';
import '../user/AllUser.css';
// import { getAllCity, cityDeletion } from "./agepolicyAction";
import { getAllProductCommission, productcommissionDeletion } from "../commission/commissionAction";
import { useDispatch, useSelector } from "react-redux";
import store from "../../../store";
import { useLocation, Link, useNavigate } from 'react-router-dom';
import Tooltip from '@mui/material/Tooltip';
import { getSRolePermission } from '../userRolePermission/rolepermissionAction';

const MasterPage = () => {
    const { productcomission, isLoading } = useSelector((state) => state.productcommissionList);
    console.log("beeg",productcomission)
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getAllProductCommission());
    }, []);

    if (isLoading) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl justify-content-center">
                    <h2>Loading.....</h2>
                    {isLoading && <Spinner variant='info' center="true" animation='border' />}
                    {/*  <CountryList /> */}
                </Container>
            </>
        );
    }

    if (productcomission.length === 0) {
        return (
            <>
                <Container className="my-4 mx-4 container-xl">
                    <div style={{ display: 'block', justifyContent: 'flex-start' }}><Link className="btn alink btncolorb" variant="btncolorb" to="/createExcursionCommission/Excursion"><FaPlus className='fwcolor' /> Add Commission Details</Link>{' '}</div>
                </Container>
                <Container className="my-4 mx-4 container-xl">

                    <h2>No Product Commission to display.....</h2>
                    
                   
                </Container>
                
            </>
        );
    }

  
    return (
        <Container>

            <div className="users">
                <ProductCommissionList skey={productcomission.result2} />
            </div>
        </Container>
    );
}

const ProductCommissionList = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [productcomissionid, setProductCommissionid] = useState('');

    useEffect(() => {
        dispatch(getSRolePermission());
        
    }, []);
  
    const { permissionisLoading, combinedrolepermissiondetails } = useSelector(
        (state) => state.rolePermissionList
      );
  
      const filteredPermissions = combinedrolepermissiondetails.filter(
        (item) => item.label === "Product Commission"
      );
      
      let menu_add = 0;
      let menu_edit = 0;
      let menu_delete = 0;
      
      if (filteredPermissions.length > 0) {
        const permission = filteredPermissions[0];
        menu_add = permission.menu_add;
        menu_edit = permission.menu_edit;
        menu_delete = permission.menu_delete;
      }
  

    const onProductCommissionDelete = (e, id) => {
        e.preventDefault();
         setProductCommissionid(id);
        //console.log('delete :'+ id);

        dispatch(productcommissionDeletion(id));
        dispatch(getAllProductCommission());
        navigate('/excursionCommissionList/Excursion');
        getAllProductCommission(); 
        //  window.location.reload(true);

    }



    const onProductCommissionModify = (e, id) => {
         e.preventDefault();
        //console.log('select role '+id);
        navigate('/ViewDetails/' + id); 
    }
    function rowClickEvent(param) {
        alert('Row Click Event');
    }

    const data = () => {
        
        const rData = props.skey.filter(obj => obj.status == "Pending").map((user,index) => {
   
            const productcomissionData = JSON.parse(JSON.stringify(user));
            // console.log('hell '+usersData.id);
            const rowData = {
                 id: index + 1,
                name: productcomissionData.product_name,
                // status: productcomissionData.status == 'Approved' ? <span className="badge bg-success"> Approved</span> : <span className="badge bg-danger"> Pending</span>,
                action: <>{menu_edit===1 &&(<Button className="btn btn-sm btn-success" onClick={(e) => onProductCommissionModify(e, productcomissionData.product_id)} ><FaEye className='fwcolor' /></Button>)}</>,
             }
            // console.log('rowData '+rowData.action);
            return rowData;
        });

        //   console.log(rData);

        return {
            columns: [
                {
                    label: '#ID',
                    field: 'id',
                    width: 40,
                    sort: 'asc',
                    attributes: {
                        'aria-controls': 'DataTable',
                        'aria-label': 'ID',
                    },
                },
                {
                    label: 'Product Name',
                    field: 'name',
                    width: 200,
                },
                // {
                //     label: 'Status',
                //     field: 'status',
                //     width: 100,
                // },
                {
                    label: 'Action',
                    field: 'action',
                    width: 200,
                    sort: 'disabled',
                },
            ],
            rows: rData,

        };
    };

    return (
        <>
            <Container className="my-4  container-xl">

                <Card style={{marginTop:'-80px'}}>
                    <Card.Header><h4 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Approval Product Commission List </h4> <div style={{ display: 'flex', justifyContent: 'flex-start' }}>{' '}</div> </Card.Header>
                    <Card.Body>
                        <div>
                        <Link to="/"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 

                        </div>
                        <br />
                       
                        <CDBContainer>
                            <CDBCard>
                                <CDBCardBody>
                                 
                                    {data()?.rows?.length  > 0 ? <>
                                        <CDBDataTable
                                            responsive
                                            striped
                                            bordered
                                            hover
                                            maxHeight="300px"
                                            noBottomColumns={true}
                                            style={{ width: '878px' }}
                                            data={data()}
                                            materialSearch
                                            fullPagination
                                        />
                                </>: <> <div style={{width:"900px",textAlign:'center'}}>No data available.</div>
                                </>}
                                </CDBCardBody>
                            </CDBCard>
                        </CDBContainer>

                    </Card.Body>
                </Card>
                

            </Container>
        </>
    );
};


export default MasterPage;